import {TourSteps} from './interface/tour-steps.interface';
import Step from 'shepherd.js/src/types/step';
import {LocalStorageEnum} from '../../../enums/utils';
import {ToursEnum} from '../../../enums/tour';

export const viewSchedulesStep: (tourSteps: TourSteps) => Step.StepOptions[] =
  ({steps, buttons, services, cb}: TourSteps): Step.StepOptions[] => {
    return [
      {
        ...steps.default,
        scrollTo: {
          inline: 'start',
          block: 'start',
          behavior: 'smooth',
        },
        id: 'viewSchedulesStep1',
        title: 'Día actual',
        text: `De forma predeterminada se muestra la agenda en el día actual. Puedes cambiar de día dando clic en las flechas de izquierda y derecha. Da clic en el botón para continuar.`,
        attachTo: {
          element: '.buttons-today .elements',
          on: 'top'
        },
        canClickTarget: false,
        beforeShowPromise: async () => {
          return new Promise((resolve): void => {
            setTimeout((): void => {
              resolve(true);
            }, 1000);
          });
        },
      },
      {
        ...steps.default,
        id: 'viewSchedulesStep2',
        title: 'Modo de visualización',
        text: `Hay 3 formas de visualización de la agenda, puedes intercambiar entre ellas de acuerdo a tus necesidades. Da clic en el botón para continuar.`,
        attachTo: {
          element: '.buttons-set .elements',
          on: 'bottom'
        },
        canClickTarget: false,
      },
      {
        ...steps.default,
        scrollTo: {
          inline: 'end',
          block: 'center',
          behavior: 'smooth',
        },
        id: 'viewSchedulesStep3',
        title: 'Citas del día',
        text: `Da clic para desplegar las citas del día seleccionado.`,
        attachTo: {
          element: '.cal-month-view .cal-day-cell.cal-today',
          on: 'bottom'
        },
        advanceOn: {
          selector: '.cal-month-view .cal-day-cell.cal-today',
          event: 'click'
        },
        buttons: [{...buttons.cancel}],
      },
      {
        ...steps.default,
        scrollTo: {
          inline: 'end',
          block: 'start',
          behavior: 'smooth',
        },
        id: 'viewSchedulesStep4',
        title: 'Mostrar detalles de la cita',
        text: `¡Muy bien!. Has finalizado el tour de "Agenda". La cita DEMO debe ser removida por integridad de los datos y serás redirigido ${(services.storageService.getLocalItem(LocalStorageEnum.FORCE_TOUR_NAME) === ToursEnum.CHECK_SCHEDULE) ? 'a la página de tours.' : 'para continuar con los tours.'}`,
        attachTo: {    // @ts-ignore
          on: 'bottom'
        },
        buttons: [
          {
            // tslint:disable-next-line:typedef
            action(): void {
              cb();
            },
            text: 'Entendido'
          },
          {...buttons.cancel},
        ],
        canClickTarget: false,
        classes: '',
      }
    ];

  };
